<template>
  <b-modal
    v-if="library"
    id="modal-library"
    :no-close-on-backdrop="true"
    :no-close-on-esc="false"
    :title="library.title||$t('New File')"
    :ok-only="true"
    :ok-title="$t('Close')"
    @ok="close"
    @close="close"
  >

    <div class="text-center">
      <b-avatar
        size="60"
        :variant="library.variant"
      >
        <feather-icon
          size="38"
          :icon="library.icon"
        />
      </b-avatar>
      <h3 class="mt-1 mb-2">{{ library.title }}
        <br><small>{{ formatDate(library.createDate) }}</small>
      </h3>
      <p class="text-left">
        {{ library.body }}
      </p>

      <div
        v-for="(file,index) in library.files"
        :key="index"
        class="p-1 text-left"
      >
        <b-link @click="downloadFile(file)">
          {{ file }}
        </b-link>
      </div>

    </div>

  </b-modal>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BModal, VBModal, BAvatar, BLink,
} from 'bootstrap-vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export default {
  components: {
    BModal,
    BAvatar,
    BLink,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      library: null,
    }
  },
  mounted() {
    this.$root.$on('read_library', library => {
      this.library = library
      this.$nextTick(() => {
        this.$bvModal.show('modal-library')
        this.setAsRead()
      })
    })
  },
  beforeDestroy() {
    this.$root.$off('read_library')
  },
  methods: {
    openFile(response, filename) {
      const type = response.headers['content-type']
      const blob = new Blob([response.data], {
        type,
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      link.remove()
    },
    downloadFile(file) {
      useJwt.axiosIns.get(`library/download/${file}`, { responseType: 'arraybuffer' })
        .then(response => {
          if (response.data) {
            this.openFile(response, file)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    setAsRead() {
      useJwt.axiosIns.patch(`library/setAsRead/${this.library.id}`)
        .then(() => {
          this.$root.$emit('refresh_library')
        })
        .catch(e => {
          console.log(e)
        })
    },
    close() {
      this.$bvModal.hide('modal-library')
    },
    formatDate(date) {
      return dayjs(date).fromNow()
    },
  },
}
</script>
